import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import FissaggiTettoDialog from "@/components/FissaggiTettoDialog";
import ZavorreDialog from "@/components/ZavorreDialog";

const TITLES = { fissaggi_inclinato: "Fissaggi tetto inclinato", fissaggi_piano: "Fissaggi tetto piano", zavorre: "Pre-dimensionamento zavorre" };

export default function StrumentoTecnico() {
  const { token } = useParams();
  const [link, setLink] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    window.__TOOL_TOKEN = token;
    api.get("/strumenti/sessione").then((r) => setLink(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Link scaduto o non valido: riaprilo dal configuratore"));
    return () => { delete window.__TOOL_TOKEN; };
  }, [token]);

  const piano = link?.tool === "fissaggi_piano";
  return (
    <div className="min-h-screen bg-background" data-testid="strumento-page">
      <header className="flex items-center gap-3 border-b border-border px-5 py-3">
        <img src="/torri-mark.png" alt="Torri" className="h-7 w-7" />
        <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-primary" data-testid="strumento-title">{TITLES[link?.tool] || "Tools tecnici"}</span>
        {link?.config?.summary?.cliente && <span className="text-xs text-muted-foreground">· {link.config.summary.cliente}</span>}
      </header>
      <main className="p-6">
        {error ? <p className="text-sm text-destructive" data-testid="strumento-error">{error}</p>
          : !link ? <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          : <p className="text-xs text-muted-foreground" data-testid="strumento-hint">Strumento aperto dal configuratore. Calcola, scarica il PDF e premi «Salva consulenza» per archiviarla nel configuratore.</p>}
      </main>
      {link && link.tool !== "zavorre" && (
        <FissaggiTettoDialog open onOpenChange={() => {}} link={link} moduleRow={null} tettoConfig={null}
          forceTipo={piano ? "piano" : undefined} inclinatoOnly={!piano} pianoOnly={piano} pdfMode
          installerName={link.config?.installer?.ragione_sociale} installerIsPartner={!!link.config?.is_partner}
          installerId={link.config?.installer?.id} onApply={() => {}} />
      )}
      {link && link.tool === "zavorre" && (
        <ZavorreDialog open onOpenChange={() => {}} link={link} installerId={link.config?.installer?.id}
          installerName={link.config?.installer?.ragione_sociale} installerIsPartner={!!link.config?.is_partner} />
      )}
    </div>
  );
}
